import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { LimitReachedDialogComponent } from './limit-reached-dialog.component';

@NgModule({
  declarations: [LimitReachedDialogComponent],
  imports: [CommonModule, MatIconModule, MatDialogModule, MatButtonModule, TranslocoModule]
})
export class LimitReachedDialogModule {}
